/**
 * Consent flow ids; values match CareBus / provider-api
 * ``OrderingDomainConfig.consentFlow`` on the wire (UPPER_CASE), so they must not change.
 *
 * Lives here, not in `@/config/uiConfig`, so pure ordering helpers can use it
 * without pulling in (or being broken by mocks of) the UI config module.
 */
export enum ConsentFlow {
  PractitionerMediated = 'PRACTITIONER_MEDIATED',
  PractitionerMediatedAb = 'PRACTITIONER_MEDIATED_AB',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
}

/**
 * True for practitioner-mediated flows: `PRACTITIONER_MEDIATED` (A) and
 * `PRACTITIONER_MEDIATED_AB` (A/B hybrid). The SPA treats AB exactly like PM
 * wherever it branches on mode; it must never be treated as `PRIMARY`.
 */
export function isPmLikeConsentFlow(flow: string | null | undefined): boolean {
  const normalized = (flow ?? '').trim()
  return normalized === ConsentFlow.PractitionerMediated || normalized === ConsentFlow.PractitionerMediatedAb
}
